import React, { useEffect, useState } from "react";
import { MODULE_API } from "../../apis";
import * as Styles from "./Styles/InsuranceSubformStyle";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { FormCreator } from "./components/FormCreator";
import "./Styles/InsuranceAllocationStyle.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
const InsuranceAllocationSubform = () => {
  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  const { view } = useParams();
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("");
  const [submitBody, setSubmitBody] = useState({});
  const [fieldsData, setFieldsData] = useState({});
  const [attributes, setAttributes] = useState({});
  // Fetch insurance fields
  const getInsuranceFields = async (Name) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAttributes(sortedAttributes && sortedAttributes);
        sortedAttributes &&
          sortedAttributes.map((attribute) => {
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
    } finally {
      setIsLoading(false);
    }
  };
  // Fetch insurance fields data
  const getInsuranceFieldsData = async (id) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.fetchSingleGoalDetails(id);
      if (res && res.data) {
        setFieldsData(res.data);
      }
    } finally {
      setIsLoading(false);
    }
  };
  // Create dynamic tabs from attributes
  const createDynamicTabs = (fields) => {
    const newTabs = Object.keys(fields).map((key, index) => ({
      name: key.toUpperCase(),
      enabled: true,
      priority: index + 1,
    }));
    setTabs(newTabs);
  };
  // Handle previous button click
  const handlePreviousFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a - 1];
    setActiveTabName(tabsControl[b]);
  };

  // Handle next button click
  const handleNextFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a + 1];
    setActiveTabName(tabsControl[b]);
  };
  // Handle submit
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      console.log("submitBody", submitBody);
        if (moduleName && !moduleId) {
          const moduleNew = await MODULE_API.addAsset(moduleName, {
            clientModules: [{ ...submitBody, }],
          });
        } else if (moduleId && moduleName && !view) {
          await MODULE_API.updateClientModule(moduleId, { ...submitBody,});
        }
      setIsLoading(false);
      history.push("/organizer/insurance");
    } catch (error) {
      swal({
        title: "Error",
        text: "Error while Saving Module",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
    } finally {
      setIsLoading(false);
    }
  };
  // Set current tab
  const currentTab = (tab) => {
    let tabs2 = tabs && tabs.map((tab) => tab.name);
    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  };
  // Update tabs when fields change
  useEffect(() => {
    setTabs(Object.keys(fields));
    console.log("fields", fields);
    createDynamicTabs(fields);
  }, [fields]);

  // Set active tab on initial load
  useEffect(() => {
    if (tabs.length > 0) {
      currentTab(tabs[0].name);
    }
  }, [tabs]);
  useEffect(() => {
    const tabNamesArray = tabs && tabs.map((tab) => tab.name);
    let temp = tabNamesArray.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);
  useEffect(() => {
    console.log("module", module, id);
    fetchAll();
  }, [module, id]);

  const fetchAll = async () => {
    if (module) {
      await getInsuranceFields(module);
      setModuleName(module);
    }
    if (id) {
      await getInsuranceFieldsData(id);
      setModuleId(id);
    }
  };

  // Create tabs control for navigation
  useEffect(() => {
    const tabsControl = {};
    tabs.forEach((tab, index) => {
      tabsControl[index + 1] = tab.name;
    });
    setTabsControl(tabsControl);
  }, [tabs]);
  const allTabs =
    tabs &&
    tabs.reduce((acc, tab, index) => {
      acc[tab.name] = {
        name: tab.name,
        enabled: tab.enabled,
        priority: tab.priority,
      };
      return acc;
    }, {});
  console.log("allTabs", tabs);
  const tabNamesArray = tabs && tabs.map((tab) => tab.name);
  return (
    <div style={{ position: "relative" }}>
      <hr />
      <TabNavigationComponent
        tabs={tabNamesArray}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        currentTab={currentTab}
        AllTabs={allTabs}
      />
      <hr />
      <form>
        {tabNamesArray.length > 0 && (
          <FormCreator
            data={fields[tabNamesArray[activeTabIndex]]}
            attributes={attributes && attributes}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            activeTabName={activeTabName}
          />
        )}
      </form>
      {tabs.length > 0 && (
        <div className="insuranace-form-buttons-conatiner">
          <button
            onClick={handlePreviousFormButton}
            className="insuranace-form-previous-button"
            disabled={activeTabName === tabs[0].name}
          >
            Previous
          </button>
          {activeTabName === tabs[tabs.length - 1].name ? (
            <button
              onClick={handleSubmit}
              className="insuranace-form-Submit-button"
            >
              Submit
            </button>
          ) : (
            <button
              onClick={handleNextFormButton}
              className="insuranace-form-Submit-button"
            >
              Next
            </button>
          )}
        </div>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  setActiveTabIndex,
  activeTabName,
  setActiveTabName,
  currentTab,
  AllTabs,
}) => {
  return (
    <div className="tab-navigation">
      <Styles.TabContainer>
        <div
          style={{
            width: "1400px",
            display: "flex",
            margin: "0 2rem",
            justifyContent: "center",
          }}
        >
          {AllTabs &&
            Object.keys(AllTabs).map((tabName, tabIndex) => {
              return (
                <React.Fragment key={tabIndex}>
                  {tabIndex > 0 && (
                    <Styles.SpacerLine
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                    ></Styles.SpacerLine>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "70px",
                    }}
                  >
                    <Styles.TabBox
                      onClick={() => {
                        if (AllTabs[tabName].enabled) {
                          currentTab(AllTabs[tabName].name);
                          setActiveTabName(AllTabs[tabName].name);
                          setActiveTabIndex(tabIndex);
                        }
                      }}
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                      isActive={AllTabs[tabName].name == activeTabName}
                      isEnabled={AllTabs[tabName].enabled}
                    >
                      <Styles.TabBoxNumber>
                        {AllTabs[tabName].priority}
                      </Styles.TabBoxNumber>
                    </Styles.TabBox>
                    <p style={{ margin: "10px 0", textAlign: "center" }}>
                      {AllTabs[tabName].name}
                    </p>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </Styles.TabContainer>
    </div>
  );
};
export default InsuranceAllocationSubform;
